import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core'
import { provideState } from '@ngrx/store'
import { provideEffects } from '@ngrx/effects'

import { AGGREGATIONS_FEATURE_TOKEN } from '@features/aggregations/constants/aggregation.constants'
import { aggregationsReducer } from '@features/aggregations/store/reducers/aggregations.reducer'
import { AggregationsEffects } from '@features/aggregations/store/effects/aggregations.effects'

export function provideAggregations(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(AGGREGATIONS_FEATURE_TOKEN, aggregationsReducer),
    provideEffects([AggregationsEffects])
  ])
}
